// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
  dot: {
    defaultMessage: ',',
    id: 'keyboard.buttons.dot'
  }
});
